import styled, { css } from "styled-components";
import { ToggleIconWrapper } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import * as CashPrice from "../../price/styles/CashPrice";
import * as BasketList from "./BasketList";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { ctaStyle } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";

export const ToggleIcon = styled(ToggleIconWrapper)``;

export const HeaderToggle = styled.div<{ isCollapsible?: boolean }>`
    display: flex;
    flex: 1;
    flex-direction: row;
    margin-top: ${theme.space[1]}px;
    ${({ isCollapsible }) =>
        isCollapsible &&
        css`
            cursor: pointer;
        `};
`;

export const HeaderToggleInner = styled.div<{ isOpen?: boolean }>`
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: ${theme.space[1]}px 0;
    border-bottom: 1px solid ${({ isOpen }) => (isOpen ? "transparent" : theme.colors.platinumLight)};

    /* Align height (center) in HeaderToggleInner */
    ${CashPrice.Text} {
        position: relative;
        top: -2px;
    }
`;

export const ContentWrapper = styled.div`
    padding-bottom: ${theme.space[2]}px;
    border-bottom: 1px solid ${theme.colors.platinumLight};

    ${BasketList.BasketList} {
        padding: ${theme.space[1]}px ${theme.space[2]}px;
        background-color: ${theme.colors.white};
    }
`;

export const HeaderToggleTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: flex-start;
    margin-right: auto;
    color: ${theme.colors.azure};
    span {
        margin-right: 4px;
    }
    ${ctaStyle};

    html[dir="rtl"] & {
        margin-left: auto;
        margin-right: 0;
        span {
            margin-left: 4px;
            margin-right: 0;
        }
    }
`;

export const Counter = styled.span`
    display: inline-block;
    position: relative;
    top: -2px;
    height: ${theme.space[2]}px;
    margin: 0 0 0 ${theme.space[1]}px;
    padding: 0 ${theme.space[1]}px;
    font-size: 1rem;
    letter-spacing: 0;
    line-height: ${theme.space[2]}px;
    text-align: center;
    color: ${theme.colors.white};
    background: ${theme.colors.azure};
    border-radius: 10px;
`;

export const HeaderToggleDetails = styled.div`
    display: flex;
    align-items: center;
    ${CashPrice.Text} {
        font-family: ${theme.fonts.regular};
        font-size: 1.4rem;
        letter-spacing: 0.05em;
        line-height: 1.9rem;
        color: ${theme.colors.azure} !important;
    }
    /* Fix alignment icon in IconWrapper */
    .icon {
        margin-top: -2px;
    }
`;
